import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutUs.css';
import photo from '../assets/logo.png';

function AboutUs() {
    const [showMore, setShowMore] = useState(false);

    return (
        <section className="about-section" id="about" aria-labelledby="about-title">
            <div className="about-shell">
                <div className="about-text">
                    <span className="about-kicker">Om oss</span>
                    <h2 id="about-title">Riktigt Rent - Förstklassig städning med lokal närvaro</h2>
                    <div className={`about-body ${showMore ? 'expanded' : ''}`}>
                        <p>
                            Med 15+ års erfarenhet i Östergötland levererar Riktigt Rent pålitlig, premium städning för hem,
                            kontor och byggprojekt. Vi kombinerar noggrannhet, service och hållbara metoder.
                        </p>
                        <p>
                            Vårt team består av utbildade proffs med bakgrundskontroll och checklistor för trygg, jämn kvalitet -
                            både för RUT-uppdrag och företagsavtal.
                        </p>
                        <p>
                            Vi använder miljövänliga produkter och moderna arbetssätt för att skapa rena, hälsosamma miljöer utan att kompromissa med hållbarhet.
                        </p>
                    </div>
                    <button
                        type="button"
                        className="about-readmore"
                        onClick={() => setShowMore((open) => !open)}
                        aria-expanded={showMore}
                    >
                        {showMore ? 'Visa mindre' : 'Läs mer'}
                    </button>
                    <div className={`about-highlights ${showMore ? 'expanded' : 'collapsed'}`}>
                        <div>
                            <strong>Miljövänligt</strong>
                            <p>Certifierade produkter och rutiner som värnar människor och miljö.</p>
                        </div>
                        <div>
                            <strong>Tryggt team</strong>
                            <p>Utbildade proffs med bakgrundskontroll och tydliga checklistor.</p>
                        </div>
                        <div>
                            <strong>Skräddarsytt</strong>
                            <p>Upplägg för hem, företag och entreprenader - flexibla tider och SLA:er.</p>
                        </div>
                    </div>
                    <div className="about-cta-row">
                        <Link className="about-cta primary" to="/kontakt">Boka konsultation</Link>
                        <Link className="about-cta ghost" to="/services">Se tjänster</Link>
                    </div>
                    <div className="about-stats" aria-label="Nyckeltal">
                        <div className="stat">
                            <span className="stat-value">15+</span>
                            <span className="stat-label">År av erfarenhet</span>
                        </div>
                        
                        <div className="stat">
                            <span className="stat-value">100%</span>
                            <span className="stat-label">Nöjd-kund-garanti</span>
                        </div>
                    </div>
                </div>

                <div className="about-map-card">
                    <div className="map-header">
                        <div className="map-badge">Östergötland</div>
                        <span>Vi täcker Linköping, Norrköping och hela regionen.</span>
                    </div>
                    <div className="map-frame" role="img" aria-label="Karta över Östergötland">
                        <iframe
                            title="Östergötland karta"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d85521.95596171264!2d15.4664076!3d58.4108194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46596e7800f5d18f%3A0x4034506de8d3c10!2zT8WIdGVyZ8O2dGxhbmQ!5e0!3m2!1ssv!2sse!4v1700000000000!5m2!1ssv!2sse"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            allowFullScreen
                        />
                    </div>
                    <div className="map-footer">
                        <img src={photo} alt="RiktigtRent" />
                        <div>
                            <p>Behöver du städning i regionen?</p>
                            <Link className="about-cta ghost" to="/kontakt">Kontakta oss</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutUs;
